import { AdditionalTypeEnum, CoveragePayerType, CoverageTypeAtManufacturer, DisabilityRisk, DiscountTerms, DiscountType, FixedOrVariableSum, InsurancePaymentFrequency, InsurancePlanType, InsuranceSumRate, InsuranceType, InsuredType, OccupationType, PayoutMethod, UnderwritingType, WaitingPeriod, YesNo } from "../interfaces/DTO/mislaka_xml_insurence_models";
import { PolicyOrAccount } from "../interfaces/DTO/mislaka_xml_models";
import { BeneficiaryDefinition, BeneficiaryIDCode, BeneficiaryIdentificationType, BeneficiaryType, RelationType } from "../interfaces/DTO/mislaka_xml_pension_models";
import { formatPensionPlanType, formatPensionRegulationType } from "./enumFormatter";

export function formatRelationType(relationType: RelationType): string {
    switch (relationType) {
      case RelationType.PARENTS:
        return "הורים";
      case RelationType.SPOUSE:
        return "בן/בת זוג";
      case RelationType.CHILD:
        return "ילד/ה";
      case RelationType.SIBLING:
        return "אח/אחות";
      case RelationType.GIFT_GIVER:
        return "מעניק מתנה";
      case RelationType.GUARDIAN:
        return "אפוטרופוס";
      case RelationType.EMPLOYER:
        return "מעסיק";
      case RelationType.OTHER:
        return "אחר";
      case RelationType.BANK_LENDER:
        return "בנק מלווה (עבור משכנתאות)";
      case RelationType.INSTITUTIONAL_LENDER:
        return "מוסדי מלווה (עבור משכנתאות)";
      case RelationType.OTHER_LENDER:
        return "מלווה אחר (עבור משכנתאות)";
      default:
        return "לא ידוע";
    }
  }

  export function formatBeneficiaryType(type: BeneficiaryType): string {
    switch (type) {
      case BeneficiaryType.LIFE_BENEFICIARY:
        return "מוטב למקרה חיים";
      case BeneficiaryType.DEATH_BENEFICIARY:
        return "מוטב למקרה מוות";
      default:
        return "לא ידוע";
    }
  }

  export function formatBeneficiaryDefinition(definition: BeneficiaryDefinition): string {
    switch (definition) {
      case BeneficiaryDefinition.REGULAR:
        return "רגיל";
      case BeneficiaryDefinition.IRREVOCABLE:
        return "בלתי חוזר";
      default:
        return "לא ידוע";
    }
  }

  export function formatBeneficiaryIdentificationType(type: BeneficiaryIdentificationType): string {
    switch (type) {
      case BeneficiaryIdentificationType.INDIVIDUAL:
        return "פרטי";
      case BeneficiaryIdentificationType.CORPORATION:
        return "תאגיד";
      case BeneficiaryIdentificationType.LEGAL_HEIRS:
        return "יורשים חוקיים";
      case BeneficiaryIdentificationType.WILL:
        return "צוואה";
      case BeneficiaryIdentificationType.SURVIVOR:
        return "שאיר";
      case BeneficiaryIdentificationType.OTHER:
        return "אחר";
      case BeneficiaryIdentificationType.NOT_SPECIFIED:
        return "לא נקבעו מוטבים על ידי הלקוח";
      default:
        return "לא ידוע";
    }
  }

  export function formatBeneficiaryIDCode(code: BeneficiaryIDCode): string {
    switch (code) {
      case BeneficiaryIDCode.ID_NUMBER:
        return "מספר תעודת זהות";
      case BeneficiaryIDCode.PASSPORT:
        return "מספר דרכון";
      case BeneficiaryIDCode.OTHER:
        return "אחר";
      default:
        return "לא ידוע";
    }
  }
  export function formatAdditionalType(type: AdditionalTypeEnum): string {
  switch (type) {
    case AdditionalTypeEnum.MEDICAL_PERCENTAGE:
      return "תוספת רפואית באחוזים";
    case AdditionalTypeEnum.MEDICAL_PROMIL:
      return "תוספת רפואית בפרומיל";
    case AdditionalTypeEnum.PROFESSIONAL_HOBBY_PERCENTAGE:
      return "תוספת מקצועית / תחביב באחוזים";
    case AdditionalTypeEnum.PROFESSIONAL_HOBBY_PROMIL:
      return "תוספת מקצועית / תחביב בפרומיל";
    case AdditionalTypeEnum.MEDICAL_AMOUNT:
      return "תוספת רפואית בסכום";
    case AdditionalTypeEnum.PROFESSIONAL_HOBBY_AMOUNT:
      return "תוספת מקצועית / תחביב בסכום";
    default:
      return "";
  }
}

  export const formatYesNo = (value: YesNo): string => {
    switch (value) {
      case YesNo.YES:
        return "כן";
      case YesNo.NO:
        return "לא";
      default:
        return "";
    }
  };
  export const formatCoveragePayerType = (type: CoveragePayerType): string => {
    switch (type) {
      case CoveragePayerType.EMPLOYER:
        return "מעסיק";
      case CoveragePayerType.EMPLOYEE:
        return "עובד";
      case CoveragePayerType.EMPLOYER_WITH_SALARY_PERCENTAGE_CAP:
        return "מעסיק עם תקרה של אחוז מהשכר";
      case CoveragePayerType.EMPLOYER_WITH_CAP_AND_EMPLOYEE_COVERAGE:
        return "מעסיק עם תקרה של אחוז מהשכר והיתרה ע'ח העובד";
      case CoveragePayerType.EMPLOYER_WITH_CAP_AND_CONTRIBUTIONS_COVERAGE:
        return "מעסיק עם תקרה של אחוז מהשכר והיתרה ע'ח הפרשות";
      case CoveragePayerType.FROM_CONTRIBUTIONS:
        return "מתוך ההפרשות";
      default:
        return "לא ידוע";
    }
  };
  
  export const formatYesNoBoolean = (value: YesNo): boolean | null => {
    switch (value) {
      case YesNo.YES:
        return true;
      case YesNo.NO:
        return false;
      default:
        return null;
    }
  };
  export const formatOccupationType = (type: OccupationType): string => {
    switch (type) {
      case OccupationType.ANY_OCCUPATION:
        return "כל עיסוק";
      case OccupationType.REASONABLE_OTHER_OCCUPATION:
        return "עיסוק סביר אחר";
      case OccupationType.SPECIFIC_OCCUPATION:
        return "עיסוק ספציפי";
      default:
        return "";
    }
  };
  
  export const formatInsuredType = (type: InsuredType): string => {
    switch (type) {
      case InsuredType.PRIMARY:
        return "ראשי";
      case InsuredType.SECONDARY:
        return "משני";
      case InsuredType.CHILD:
        return "ילד";
      case InsuredType.MUTUAL:
        return "הדדי";
      case InsuredType.OTHER:
        return "אחר";
      default:
        return "לא ידוע";
    }
  };
  export const formatPensionNameExtended = (policy: PolicyOrAccount): string => {
    if (!policy) return "לא ידוע";
  
    // ניסיון להשיג את סוג הפנסיה והרגולציה
    const pensionPlanType = policy.pension_data?.pension_plan_type || 0;
    const pensionRegulationType = policy.pension_data?.pension_regulation_type || 0;
  
    // אם קיימים נתונים עבור סוג הפנסיה
    if (pensionPlanType !== 0 ) {
      return `${formatPensionPlanType(pensionPlanType)} ${formatPensionRegulationType(pensionRegulationType)}`;
    }
  
    // אם אין סוג פנסיה, לבדוק `retirement_savings_by_age`
    const hasGuaranteedFactor = policy.retirement_savings_by_age?.some(
      (savings) => savings.guaranteed_conversion_factor && savings.guaranteed_conversion_factor > 0
    );
  
    if (hasGuaranteedFactor) {
      return "ביטוח מנהלים";
    }
  
    // ברירת מחדל אם אין מידע מתאים
    return "";
  };
  export const formatInsurancePlanType = (code: number): string => {
    switch (code) {
      case InsurancePlanType.BASIC:
        return "יסודי";
      case InsurancePlanType.REQUESTED_INSURANCE_SUM:
        return "סכום ביטוח מבוקש";
      case InsurancePlanType.SALARY_MULTIPLES:
        return "כפולות שכר";
      case InsurancePlanType.SAVINGS_ALLOCATION_PERCENTAGE:
        return "אחוז הקצאה לחיסכון";
      case InsurancePlanType.PURE_SAVINGS:
        return "חיסכון טהור";
      default:
        return "לא ידוע";
    }
  };
  export const formatInsurancePaymentFrequency = (code: number): string => {
    switch (code) {
      case InsurancePaymentFrequency.SEMI_ANNUAL:
        return "חצי שנתי";
      case InsurancePaymentFrequency.MONTHLY:
        return "חודשי";
      case InsurancePaymentFrequency.ADJUSTED:
        return "מתואם";
      case InsurancePaymentFrequency.NON_INDEXED:
        return "לא צמוד";
      case InsurancePaymentFrequency.INDEXED_PROFITS:
        return "רווחי הצמדה";
      case InsurancePaymentFrequency.PROFIT_PARTICIPATION:
        return "משתתף ברווחים";
      case InsurancePaymentFrequency.USD:
        return "דולר";
      case InsurancePaymentFrequency.LIBOR_INDEXED:
        return "צמוד למדד הליבור";
      case InsurancePaymentFrequency.NON_USD_FOREIGN_CURRENCY_INDEXED:
        return "צמוד למטח לא דולרי";
      default:
        return "לא ידוע";
    }
  };
  export const formatInsuranceType = (type: InsuranceType): string => {
    const insuranceTypeLabels: Record<InsuranceType, string> = {
      [InsuranceType.DEATH]: "כיסוי למקרה מוות",
      [InsuranceType.OCCUPATIONAL_DISABILITY]: "נכות מקצועית",
      [InsuranceType.ACCIDENTAL_DEATH]: "מוות מתאונה",
      [InsuranceType.ACCIDENTAL_DISABILITY]: "נכות מתאונה",
      [InsuranceType.LOSS_OF_WORK_CAPACITY]: "אובדן כושר עבודה",
      [InsuranceType.PREMIUM_WAIVER]: "שחרור מתשלום פרמיות",
      [InsuranceType.CRITICAL_ILLNESS]: "מחלות קשות",
      [InsuranceType.COMBINED_SAVINGS_PLAN]: "תוכנית משולבת חיסכון",
      [InsuranceType.DEATH_AND_DISABILITY]:  "מוות + אכ'ע",

      [InsuranceType.OTHER]: "אחר",
    };
    
    return insuranceTypeLabels[type] || "לא ידוע";
  };

  export const formatFixedOrVariableSum = (type: FixedOrVariableSum): string => {
    switch (type) {
      case FixedOrVariableSum.FIXED:
        return "קבוע";
      case FixedOrVariableSum.VARIABLE:
        return "משתנה";
      default:
        return "";
    }
  };
  export const formatInsuranceSumRate = (value: InsuranceSumRate): string => {
  switch (value) {
    case InsuranceSumRate.AMOUNT:
      return "סכום ביטוח";
    case InsuranceSumRate.RATE:
      return "שיעור ביטוח";
    default:
      return "";
  }
};
export const formatDiscountTerms = (value: DiscountTerms): string => {
  switch (value) {
    case DiscountTerms.FULL_PERIOD:
      return "הנחה לכל תקופת הביטוח";
    case DiscountTerms.FIXED_TERM:
      return "הנחה לתקופה קצובה";
    case DiscountTerms.EMPLOYER_TERM:
      return "הנחה למשך תקופת העבודה אצל המעסיק";
    case DiscountTerms.NONE:
      return "לא ניתנה הנחה";
    case DiscountTerms.FIXED_EMPLOYER:
      return "הנחה לתקופה קצובה המותנית במעסיק ספציפי";
    default:
      return "";
  }
};
export const formatDiscountType = (value: DiscountType): string => {
  switch (value) {
    case DiscountType.FORCED_COST:
      return "עלות כפויה";
    case DiscountType.PERCENTAGE:
      return "הנחת באחוזים";
    case DiscountType.AMOUNT:
      return "הנחת סכום";
    case DiscountType.PROMILLE:
      return "פרומיל";
    case DiscountType.OTHER:
      return "אחר";
    default:
      return "";
  }
};
export const formatCoverageTypeAtManufacturer = (value: CoverageTypeAtManufacturer): string => {
  switch (value) {
    case CoverageTypeAtManufacturer.BASIC_INSURANCE:
      return "ביטוח יסודי";
    case CoverageTypeAtManufacturer.RIDER:
      return "נספח (ריידר)";
    default:
      return "";
  }
};
  export const formatPayoutMethod = (method: PayoutMethod): string => {
    switch (method) {
      case PayoutMethod.LUMP_SUM:
        return "סכום חד-פעמי";
      case PayoutMethod.PENSION:
        return "קצבה";
      case PayoutMethod.PERIODIC_PAYMENTS:
        return "תשלומים תקופתיים";
      case PayoutMethod.OTHER:
        return "אחר";
      case PayoutMethod.CAPITAL_AND_PENSION:
        return "הון+קצבה";
      default:
        return "לא ידוע";
    }
  };

  export const formatUnderwritingType = (type: UnderwritingType): string => {
    switch (type) {
      case UnderwritingType.MEDICAL:
        return "רפואי";
      case UnderwritingType.PROFESSIONAL_OR_HOBBY:
        return "מקצועי או תחביב";
      case UnderwritingType.UNASSIGNED:
        return "לא משויך";
      default:
        return "";
    }
  };

  export const formatWaitingPeriod = (period: WaitingPeriod): string => {
    switch (period) {
      case WaitingPeriod.MONTHS_24:
        return "24 חודשים";
      case WaitingPeriod.MONTHS_36:
        return "36 חודשים";
      case WaitingPeriod.MONTHS_48:
        return "48 חודשים";
      case WaitingPeriod.MONTHS_60:
        return "60 חודשים";
      case WaitingPeriod.FULL_PERIOD:
        return "לכל התקופה";
      default:
        return "";
    }
  };

  export const formatDisabilityRisk = (risk: DisabilityRisk): string => {
    switch (risk) {
      case DisabilityRisk.ONE_PERCENT:
        return "1%";
      case DisabilityRisk.TWO_PERCENT:
        return "2%";
      case DisabilityRisk.NO:
        return "לא";
      default:
        return "";
    }
  };

  export const formatQualificationPeriod = (months: number): string => {
    if (!months || months === 0) return "";
    if (months === 1) return "חודש אחד";
    if (months === 12) return "שנה";
    if (months % 12 === 0) {
      const years = months / 12;
      return `${years} שנים`;
    }
    return `${months} חודשים`;
  };

